module.exports = __webpack_public_path__ + "images/emoji/hushed.c30825913f0dc04e9a5b.png";